import { TableCell, TableRow } from '@material-ui/core'
import React from 'react'
import ValueChip from '../../../UI/ValueChip'
import { calculateColumnTotal, calculateGlobalTotal } from '../supplierAgreementDialog.utils'

export default function SupplierAgreementTotalsRow({ coopGroups, columns, useDynamicColumns }) {
  const isPercent = coopGroups[0]?.isPercent || false

  return (
    <TableRow style={{ fontWeight: 'bold', backgroundColor: '#f5f5f5' }}>
      <TableCell>TOTAL</TableCell>
      {useDynamicColumns ? (
        columns.map((col) => (
          <TableCell key={`total-${col.id}`}>
            <ValueChip value={calculateColumnTotal(coopGroups, col.id)} isPercent={isPercent} />
          </TableCell>
        ))
      ) : (
        <>
          <TableCell>
            <ValueChip value={0} isPercent={isPercent} />
          </TableCell>
          <TableCell>
            <ValueChip value={0} isPercent={isPercent} />
          </TableCell>
        </>
      )}
      <TableCell>
        <ValueChip value={calculateGlobalTotal(coopGroups, columns)} isPercent={isPercent} />
      </TableCell>
    </TableRow>
  )
}
